export const ACTION_TYPES = {
  SET_COLLAPSED: 'SET_COLLAPSED',
};

// Ação para alterar o valor de collapsed
export const set_collapsed = (collapsed) => ({
  type: ACTION_TYPES.SET_COLLAPSED,
  collapsed,
});
